import _ from 'lodash';
/* @ngInject */
export default function VoiceDownPanelService($sails, $q, $log, EquipmentInfoService) {
  const service = this;

  /**
   * Public Variables
   */
  service.voiceDownPanelModel = {};

  /**
   * Public Methods
   */

  service.loadClips = loadClips;
  service.getClipKeyForName = getClipKeyForName;
  service.putEquipmentsInModel = putEquipmentsInModel;
  service.playClip = playClip;
  service.stopClip = stopClip;
  service.deleteEquipment = deleteEquipment;

  /*
     *  Takes an array of equipment id strings and populates the model with equipment data
     */
  function putEquipmentsInModel(equipmentIds) {
    return EquipmentInfoService.getFullEquipment(equipmentIds)
      .then((equipments) => {
        _.forEach(equipments, (eq) => {
          service.voiceDownPanelModel[eq.id] = {
            equipment: eq
          };
        });
        return _.map(equipments, 'id');
      });
  }

  /*
     *  Fetches clips for an equipment and returns the clip key that case-insensitively
     *  matches clipName, or null if no match is found.
     */
  function getClipKeyForName(equipmentId, clipName) {
    return $sails.get(`/equipment/${equipmentId}/statuses/getClips`)
      .then((response) => {
        const clips = response.data;
        if (!clips) { return null }
        const lowerName = clipName.toLowerCase();
        const entry = Object.entries(clips).find(([, value]) => value.toLowerCase() === lowerName);
        return entry ? entry[0] : null;
      })
      .catch((error) => {
        $log.error('Error fetching clips: ', error);
        return null;
      });
  }

  /*
     *  Get clips from server for a specified equipment and sets the voiceDownPanelModel
     */
  function loadClips(equipmentId) {
    return $sails.get(`/equipment/${equipmentId}/statuses/getClips`)
      .then((response) => {
        service.voiceDownPanelModel[equipmentId].clips = response.data;
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  /*
     *  Call the server to play a specified clip on a specified equipment
     */
  function playClip(equipmentId, clipId) {
    return $sails.post(`/equipment/${equipmentId}/actions/playClip`, {
      id: equipmentId,
      clip: clipId
    })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  /*
     *  Call the server to stop clip currently playing
     */
  function stopClip(equipmentId) {
    return $sails.post(`/equipment/${equipmentId}/actions/stopClip`, {
      id: equipmentId
    })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  /*
     *  Removes equipment from the model
     *  equipment is an array of equipment strings
     */
  function deleteEquipment(equipment) {
    if (equipment) {
      _.forEach(equipment, (eq) => {
        delete service.voiceDownPanelModel[eq];
      });
    } else {
      $log.error('equipment not defined');
    }
  }
}
